<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <v-tooltip top>
          <template slot="activator">
            <div class="layout row ma-0" on="on" :style="`${ path ?'cursor:pointer;' : '' }`" @click="()=>{
                if(path){
                  goTo(path)
                }
              }">
              <div class="sm6 xs6 flex">
                <div class="layout column mt-3 justify-center align-center">
                  <v-icon size="56px" :color="color">{{icon}}</v-icon>
                </div>
              </div>
              <div class="sm6 xs6 flex text-xs-center py-3 white--text" :class="color">
                <div class="headline">{{ title }}</div>
                <span class="caption">{{ subTitle }}</span>
              </div>
            </div>
          </template>
          <span>{{tooltip}}</span>
        </v-tooltip>
      </v-container>
    </v-card-text>
  </v-card>    
</template>

<script>
export default {
  props: [
    "icon",
    "title",
    "subTitle",
    "color",
    "tooltip",
    "path",
  ],
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
  }
};
</script>